import { AppRoutes } from "./routes";

import "./index.css";

export const App = () => {
  return <AppRoutes />;
};
